(function($) {
    $(document).ready(function() {
        // 出貨櫥窗互動已搬至 js/src/shipment-window.js。
        // 本檔留空殼：handle wtoy-wc-points-workflow-myaccount-page 仍是
        // -datatable 的唯一依賴來源（廠商自取管理頁靠它載入 DataTables）。
    });
})(jQuery);
